// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__3FH18","col":"styles_col__2jXux"};